import { render, staticRenderFns } from "./my-needs.vue?vue&type=template&id=fda4b178&scoped=true"
import script from "./my-needs.vue?vue&type=script&lang=js"
export * from "./my-needs.vue?vue&type=script&lang=js"
import style0 from "./my-needs.vue?vue&type=style&index=0&id=fda4b178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4b178",
  null
  
)

export default component.exports